import React, { useEffect, useState } from 'react'

import IconTooltip from './IconTooltip'
import QuickDualDatePickers from '../shared/QuickDualDatePickers'
import { DEFAULT_DRAWER_WIDTH, TOOLTIP_LEFT } from '../utils/Constants'
import { renderSelectOptions, stringOptionFilter } from '../utils/SelectOptionTools'
import moment from 'moment'
import { Drawer, Button, Row, Col, InputNumber, Select } from 'antd'
import { mapStateToProps, mapDispatchToProps, connect } from '../../../../reducers/Dispatchers'

import '../../../../assets/quotas.scss'
import '../assets/places-definition.scss'
import { getEndDateByType } from '../../../../utils/timePeriods'
import { BODY_STYLE, SELECT_STYLE } from '../allocation/AllocationForm'

const TOOLTIP_TITLE = 'Define the total capacity of a care unit in terms of interns.'
const DRAWER_TITLE = 'Add free places'
const PLACES_TITLE = 'Places to add'
const SECTOR_TITLE = 'Care unit'
const SECTOR_KEY = 'name'
const NO_SECTOR_VALUE = '/'

const PlacesFormDrawer = props => {
  const [startDate, setStartDate] = useState(moment())
  const [endDate, setEndDate] = useState(moment())
  const [sector, setSector] = useState(null)
  const [places, setPlaces] = useState(0)

  useEffect(() => {
    if (props.date) {
      setStartDate(props.date)
      setEndDate(getEndDateByType(props.date, props.period.type))
    }
  }, [props.date, props.period])

  useEffect(() => {
    setSector(props.defaultSector ?? null)
  }, [props.defaultSector])

  const createPlaces = () => {
    props.onQuotaAdding(
      sector.id,
      places,
      startDate,
      endDate
    )

    setPlaces(0)
  }

  const handlePlacesAddition = places => {
    if (places === '') {
      setPlaces(0)
    }

    setPlaces(places)
  }

  const handleOnClose = () => {
    if (typeof props.onClose === 'function') {
      props.onClose()
    }

    setSector(null)
  }

  const handleDatesChange = (dates, dateStrings) => {
    setStartDate(dates[0])
    setEndDate(dates[1])
  }

  const renderDrawerTitle = () => {
    return (
      <div className='places-creater-drawer-title'>
        <IconTooltip
          title={TOOLTIP_TITLE}
          placement={TOOLTIP_LEFT}
        />
        <h3 style={{ textAlign: 'center', margin: '0px' }}> {props.t(DRAWER_TITLE)} </h3>
      </div>
    )
  }

  return (
    <Drawer
      title={renderDrawerTitle()}
      width={DEFAULT_DRAWER_WIDTH}
      onClose={handleOnClose}
      visible={props.visible}
      bodyStyle={BODY_STYLE}
    >
      <QuickDualDatePickers
        startDate={startDate}
        endDate={endDate}
        period={props.period}
        onDatesChange={handleDatesChange}
      />
      <div className='allocate-quota-form'>
        <Row>
          <Col span={12}>
            <h4>
              <b>
                {props.t(PLACES_TITLE)}
              </b>
            </h4>
          </Col>
          <Col span={12}>
            <InputNumber value={places} onChange={handlePlacesAddition} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <h4>
              <b>
                {props.t(SECTOR_TITLE)}
              </b>
            </h4>
          </Col>
          <Col span={12}>
            <Select
              style={SELECT_STYLE}
              value={sector ? sector.name : NO_SECTOR_VALUE}
              showSearch
              onSelect={(value, option) => setSector(option.props.data)}
              filterOption={stringOptionFilter}
            >
              {renderSelectOptions(props.sectors, SECTOR_KEY)}
            </Select>
          </Col>
        </Row>
      </div>
      <Button
        onClick={createPlaces}
        disabled={!sector}
      >
        {props.t('Add places')}
      </Button>
    </Drawer>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PlacesFormDrawer)
